var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-0" }, [
    _c("h1", [_vm._v("Los geht's!")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-0--intro" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("Button", {
          attrs: { text: "Weiter gehts...", icon: "checkmark" },
          on: {
            click: function($event) {
              return _vm.$emit("continue")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step-0--intro-title" }, [
      _vm._v("Welchen Job möchtest du besetzen,"),
      _c("br"),
      _vm._v(" welche Skills werden dafür benötigt?\n\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step-0--intro-text" }, [
      _vm._v(
        "\n\t\t\tskilldoo bietet dir auf der nächsten Seite ein ganz einfaches Klick-System:"
      ),
      _c("br"),
      _vm._v(
        "\n\t\t\tWähle einfach und schnell aus, was dein Best-Match wäre!\n\t\t"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }